import React, { useState, useEffect } from "react";
import {
  Space,
  Table,
  Form,
  theme,
  Row,
  Col,
  Input,
  DatePicker,
  Button,
  message,
} from "antd";
import axios from "axios";
import moment from "moment/moment";
import localhost from "../../constants/localhost";
import Detail from "./detail";

const mockData = Array(10)
  .fill(null)
  .map((_, index) => {
    return {
      id: index,
      title: "夜色妩媚，美景撩人",
      contentType: "图文混排",
      reporter: "一只胖团团",
      reporterPhone: "13216186259",
      reportDate: "2025-04-20 19:15:11",
      status: 1,
    };
  });

const contentTypeMap = {
  7: "图文混排",
  2: "经典 - 图文",
  3: "经典 - 视频",
  4: "问题",
  100: "资讯",
};

const Report = () => {
  const { token } = theme.useToken();
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10 });
  const [dataInfo, setDataInfo] = useState({ total: 20, dataSource: mockData });
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    const formData = form.getFieldsValue();
    if (formData.reportDate) {
      formData.reportDateStart = moment(formData.reportDate[0]).format(
        "YYYY-MM-DD"
      );
      formData.reportDateEnd = moment(formData.reportDate[1]).format(
        "YYYY-MM-DD"
      );
      formData.reportDate = undefined;
    }
    axios
      .post(`${localhost}/manage/reportManage/queryList`, {
        pageNo: 1,
        pageSize: 20,
        ...formData,
      })
      .then((res) => {
        setDataInfo({
          total: res?.data?.total || 0,
          dataSource: res?.data?.list || [],
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const pagination = {
    showTotal: (total, range) => {
      return `当前第 ${range[0]} 到 ${range[1]} 条，总共${total}条数据`;
    },
    total: dataInfo.total,
    current: pageInfo.pageNo,
    pageSize: pageInfo.pageSize,
    onChange: (page, pageSize) => {
      setPageInfo({ pageNo: page, pageSize: pageSize }, () => {
        getData();
      });
    },
    onShowSizeChange: (current, size) => {
      setPageInfo({ pageNo: current, pageSize: size }, () => {
        getData();
      });
    },
  };

  useEffect(() => {
    getData();
  }, []);

  const onSearch = () => {
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const onReset = () => {
    form.resetFields();
    setPageInfo({ pageNo: 1, pageSize: 10 });
  };

  const formStyle = {
    maxWidth: "none",
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const setDisplay = ({ id, status }) => {
    axios
      .get(
        `${localhost}/manage/reportManage/updateStatus?id=${id}&status=${status}`
      )
      .then((res) => {
        message.success("设置成功！");
        getData();
      });
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "标题",
      dataIndex: "title",
    },
    {
      title: "内容类型",
      dataIndex: "contentType",
    },
    {
      title: "举报人",
      dataIndex: "reporter",
    },
    {
      title: "举报人手机号",
      dataIndex: "reporterPhone",
    },
    {
      title: "举报时间",
      dataIndex: "reportDate",
    },
    {
      title: "内容状态",
      dataIndex: "status",
      render: (val) => {
        return val === 1 ? "显示" : "隐藏";
      },
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Detail detail={record} />
          {record.status === 1 ? (
            <a
              onClick={() => {
                setDisplay({ id: record.id, status: 0 });
              }}
            >
              隐藏
            </a>
          ) : (
            <a
              onClick={() => {
                setDisplay({ id: record.id, status: 1 });
              }}
            >
              显示
            </a>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Form
          form={form}
          name="advanced_search"
          style={formStyle}
          onFinish={onFinish}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item name="title" label="标题">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="contentId" label="内容ID">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="contentType" label="内容分类">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="reporter" label="举报人">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="reporterPhone" label="举报人手机号">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="reportDate" label="举报时间">
                <DatePicker.RangePicker />
              </Form.Item>
            </Col>
            <Col span={24}>
              <div style={{ textAlign: "right" }}>
                <Space size="small">
                  <Button type="primary" onClick={onSearch}>
                    搜索
                  </Button>
                  <Button onClick={onReset}>重置</Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
      <div style={{ marginTop: 16 }}>
        <Table
          rowKey="id"
          // loading={loading}
          columns={columns}
          dataSource={dataInfo.dataSource}
          scroll={{ x: "max-content", y: "calc(100vh - 240px - 55px - 64px)" }}
          style={{
            height: "calc(100vh - 240px)",
            overflowY: "scroll",
          }}
          pagination={pagination}
          // rowSelection={{
          //   selectedRowKeys,
          //   onChange: (keys, selectedRows) => {
          //     console.log("selectedRowKeys changed: ", keys);
          //     setSelectedRowKeys(keys);
          //   },
          // }}
        />
      </div>
    </div>
  );
};

export default Report;
